import isPropValid from '@emotion/is-prop-valid';

export const exceptStyledProps = (...exceptedProps: string[]) => ({
  shouldForwardProp: (prop: string) =>
    isPropValid(prop) && exceptedProps.every(exceptedProp => exceptedProp !== prop)
});
